import React from 'react';
import { Grid } from '@mui/material';
import { noTopGutterSx } from 'src/UIKit';
import { GroupsField } from '../../fields';
import { FieldWithProperties } from '../../FieldWithProperties';
import { SectionProps } from '../../../registry/sectionRegistry';

/**
 * Recipients (groups) field + its Visible/Required/Label properties.
 * Bound to config.recipients.
 */
export const GroupsSection: React.FC<SectionProps> = ({
  config,
  onConfigUpdate,
  options,
  selected,
  onSelect,
}) => {
  const recipients = config.recipients;

  const update = (patch: Partial<typeof recipients>) =>
    onConfigUpdate({
      recipients: {
        ...recipients,
        values: recipients?.values || [],
        visible: recipients?.visible || false,
        required: recipients?.required || false,
        ...patch,
      },
    });

  return (
    <Grid item xs={12} sx={noTopGutterSx}>
      <FieldWithProperties
        visible={recipients?.visible ?? false}
        required={recipients?.required ?? false}
        label={recipients?.label}
        onVisibleChange={visible => update({ visible })}
        onRequiredChange={required => update({ required })}
        onLabelChange={label => update({ label })}
        field={
          <GroupsField
            values={recipients?.values || []}
            onChange={values => update({ values })}
            visible={recipients?.visible || false}
            required={recipients?.required || false}
            isSelected={!!selected}
            onClick={() => onSelect?.()}
            label={recipients?.label}
            options={options?.groups || []}
          />
        }
      />
    </Grid>
  );
};
